import { render } from "./ListScroll.vue?vue&type=template&id=1049ffda"
import script from "./ListScroll.vue?vue&type=script&lang=js"
export * from "./ListScroll.vue?vue&type=script&lang=js"

import "./ListScroll.vue?vue&type=style&index=0&id=1049ffda&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__